import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'
import Mustache from 'mustache'

// Connects to data-controller="fav-btns"
export default class extends Controller {
  static targets = ['favBtn']
  connect() {
    if(window.myFavorites === null){
      this.renderAnonymousTemplate()
    }else{
      this.renderSignedTemplate()
    }
  }
  renderAnonymousTemplate(){
    const templateHtml = document.getElementById('anonymousTemplate').innerHTML
    const renderedHTML = Mustache.render(templateHtml, {})
    this.favBtnTargets.forEach((tgt) => {
      tgt.outerHTML = renderedHTML
    })
  }
  renderSignedTemplate(){
    const templateHtml = document.getElementById('signedTemplate').innerHTML
    this.favBtnTargets.forEach((tgt) => {
      const fundId = tgt.dataset.fundId
      const favorite = window.myFavorites.find((x) => x[1] === fundId)
      let favoriteId = null
      let liked = false
      if(favorite != undefined){
        favoriteId = favorite[0]
        liked = true
      }
      const renderedHTML = Mustache.render(templateHtml, {fundId: fundId, favoriteId: favoriteId, liked: liked })
      tgt.outerHTML = renderedHTML
    })
  }
}
